import baseScmService from 'services/baseScmService';

const playlistService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getPlaylistContent: build.query({
      query: (playlistId) => ({
        url: `/playlists/${playlistId}`,
      }),
      providesTags: (result, error, playlistId) => {
        return error ? [] : [{ type: 'Playlist', id: playlistId }];
      },
    }),
  }),
});

export const { useGetPlaylistContentQuery } = playlistService;

export default playlistService;
